/**
 * What the composer's controls do right now.
 *
 * Extracted because the send button used to BE the cancel button: same
 * position, same size, swapping icon and accessible name while a request ran.
 * A person who pressed send and saw nothing happen pressed the same spot
 * again and cancelled their own request -- which then looks exactly like
 * "sending does nothing" (measured 2026-08-24; it is what the symptom report
 * described, and I reproduced it by clicking twice).
 *
 * The rule this encodes: THE PRIMARY CONTROL NEVER CANCELS. While a request is
 * in flight the primary shows busy and is inert, and cancelling is a separate,
 * separately-labelled control that only exists while there is something to
 * cancel.
 */
export interface ComposerActionState {
  /** What the primary (send-position) control does when pressed. */
  primaryAction: "send" | "none"
  primaryDisabled: boolean
  /** Whether a distinct cancel control is offered at all. */
  cancelVisible: boolean
}

export function composerActionState(input: {
  running: boolean
  hasPrompt: boolean
}): ComposerActionState {
  if (input.running) {
    return { primaryAction: "none", primaryDisabled: true, cancelVisible: true }
  }
  return {
    primaryAction: "send",
    primaryDisabled: !input.hasPrompt,
    cancelVisible: false,
  }
}
